<template>
  <div class="main">
    <h2>Hier ist noch nix</h2>
    <h3>Aber bald. Genieße in der Zwischenzeit dieses Bild:</h3>
    <img src="@/assets/images/profile_test.png">
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
export default {
  "name": "PlaceholderView",
  data() {
    return {
      isAdmin: false
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg.isAdmin;
    } catch(e){
      console.error(e)
    }
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: var(--background);
  padding: 20px;
  text-align: center;
}

img {
  max-width: 80vw;
  max-height: 40vh;
  margin-top: 40px;
  border-radius: var(--radius-l);
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
}

h2 {
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: 700;
}

h3 {
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--tertiary-color);
  max-width: 600px;
  margin: 0;
}
</style>
